export const RealtimeEvents = {
  ChatJoinConversation: "chat:join_conversation",
  ChatLeaveConversation: "chat:leave_conversation",
  ChatMessageCreated: "chat:message_created",
  ChatConversationUpdated: "chat:conversation_updated",
  ChatUnreadThreadsCountUpdated: "chat:unread_threads_count_updated",
  NotificationsSync: "notifications:sync",
  NotificationsUnreadCountUpdated: "notifications:unread_count_updated",
  NotificationsItemCreated: "notifications:item_created",
  TradeSubscribe: "trade:subscribe",
  TradeOfferCreated: "trade:offer_created",
  TradeOfferStatusUpdated: "trade:offer_status_updated",
  TradeLifecycleUpdated: "trade:lifecycle_updated",
  TradeMeetupUpdated: "trade:meetup_updated",
  TradeExchangeConfirmationUpdated: "trade:exchange_confirmation_updated",
  TradeCompleted: "trade:completed",
  TradeReviewSubmitted: "trade:review_submitted",
  TradeReviewAutoFinalized: "trade:review_auto_finalized",
} as const;

export type RealtimeEventName = (typeof RealtimeEvents)[keyof typeof RealtimeEvents];
